
const constant = {
    websiteName: "WazirWin", 
    seoWebsiteName: "WazirWin",
    baseUrl: "https://rjs.greenmorange.com/", 
    whatsAppNumber: "+919333600000", 
    instagramUrl: "https://www.instagram.com/fairbaazi/", 
    telegramUrl: "https://api.whatsapp.com/send/?phone=9333600000&text&type=phone_number&app_absent=0", 
    youTubeUrl: "https://www.youtube.com/channel/UCcaunrHXS3IK8UEhQv34uIQ", 
    apkUrl: "https://wazir-win.sgp1.cdn.digitaloceanspaces.com/android/WazirWinV1.apk", 
    landingPageLogoSize: "160px", 
    logoPath: "logo.png",
    logoPathLine: "logoline.png", 
    minDepositCoins: 100, 
    minWithdrawalCoins: 500, 
    howToPayBankVid: "https://baazi-cdn.sgp1.cdn.digitaloceanspaces.com/howtoplay/UpiToBankAccountFairBaazi.mp4", 
    numberOfIdsOnHome: 15,
    maxHoursToShowPaymentVideo: 24,

    transactionType: {
        depositWallet: 'DepositWalletRequest',
        withdrawWallet: 'WithdrawWalletRequest',
        depositId: 'DepositIdRequest',
        withdrawId: 'WithdrawIdRequest',
        createIdRequest: 'CreateIdRequest',
        changeIdPasswordRequest: 'ChangeIdPasswordRequest',
        closeIdRequest: 'CloseIdRequest',
    },
    transactionFor: {
        idDeposit: 'idDeposit',
        walletDeposit: 'walletDeposit',
        createIdDeposit: 'createIdDeposit',
        changePasswordRequest: 'changePasswordRequest'
    },
    accountType: {
        savings: 'savings',
        current: 'current'
    },
    transactionStatus: {
        success: 'success',
        scanning: 'scanning',
        failure: 'failure',
        pending: 'pending',
        created: 'created',
        error:'error',
        cancelled:'cancelled',
        approved:'approved',
        rejected:'rejected',
    },
    appHostsAndIds:[
        {
            host:'worldbaaji.com',
            appId:'79707eb0-f0af-4682-99cf-8292574112fa'
        },
        {
            host:'www.worldbaaji.com',
            appId:'6f1b0ae8-1aff-49eb-8bf8-1f67c5043688'
        },
        {
            host:'worldbazzi.vip',
            appId:'33a7d9fb-0090-4dd7-b1f4-beb3984da458'
        },
        {
            host:'www.worldbazzi.vip',
            appId:'d60b4a6d-711d-4135-8f52-a5ec30c8ef89'
        },
        {
            host:'worldbazzi.club',
            appId:'3a5cfd3f-4684-4a32-aa44-fba7b8ced64c'
        },
        {
            host:'www.worldbazzi.club',
            appId:'9e1dd607-edbb-4c5d-ad99-d24769602a94'
        },
        {
            host:'worldbazi.com',
            appId:'77e36d1f-ad2a-4097-b151-417c349eb19a'
        },
        {
            host:'www.worldbazi.com',
            appId:'18f21df9-8618-4f42-a9f2-aa6ccc4dd6ee'
        },
        {
            host:'worldbazi.club',
            appId:'ff72ee82-6c8f-4d1f-a088-ff49a4698c21'
        },
        {
            host:'www.worldbazi.club',
            appId:'6af6b778-1913-438c-b9e1-5fa2ed2396a4'
        },
        {
            host:'worldbaazi.co.in',
            appId:'daf510cf-1be9-409e-bc14-550f42bf69e0'
        },
        {
            host:'www.worldbaazi.co.in',
            appId:'fead8b49-1e36-422e-b6ad-cd394b6ce20b'
        },
        {
            host:'www.worldbaazi.in',
            appId:'367048bb-bf5e-43ae-b53b-65a09a7bd7e1'
        },
        {
            host:'worldbaazi.in',
            appId:'fd83dc31-7f01-4c3e-af1a-c7cd1df86142'
        },
        {
            host:'www.worldbaazi.com',
            appId:'e854fa63-640e-42c3-b405-c51d7bb00b56'
        },
    ]
}

export default constant;